import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useEmployeeQuery } from '../../queries/employee_gen'
import { useEmployeeEnrollmentInfoQuery } from '../../queries/employeeEnrollmentInfo_gen'
import {
  UpdateEmployeePayrollStatusMutation,
  UpdateEmployeePayrollStatusMutationVariables,
  useUpdateEmployeePayrollStatusMutation,
} from './updateEmployeePayrollStatus_gen'

export type { UpdateEmployeePayrollStatusMutation, UpdateEmployeePayrollStatusMutationVariables }

export const useUpdateEmployeePayrollStatus = (
  mutationOptions?: UseGqlMutationCallbacks<
    UpdateEmployeePayrollStatusMutation,
    UpdateEmployeePayrollStatusMutationVariables
  >
) =>
  useUpdateEmployeePayrollStatusMutation(
    useMutationOptionsWithInvalidation(mutationOptions, [
      useEmployeeEnrollmentInfoQuery.getKey(),
      useEmployeeQuery.getKey(),
      ['OrgEmployeeList'], // invalidate all OrgEmployeeList queries
    ])
  )
